export default {
  __html: `<g fill="#currentColor" fill-rule="evenodd">
                <path d="M20.153 23H3.847C1.726 23 0 21.4 0 19.434V3.566C0 1.6 1.726 0 3.847 0h16.306C22.274 0 24 1.6 24 3.566v2.639c0 .656-.574 1.188-1.283 1.188-.708 0-1.282-.532-1.282-1.188V3.566c0-.655-.575-1.188-1.282-1.188H3.847c-.707 0-1.282.533-1.282 1.188v15.868c0 .655.575 1.188 1.282 1.188h16.306c.707 0 1.282-.533 1.282-1.188v-7.095c0-.656.574-1.188 1.282-1.188.71 0 1.283.532 1.283 1.188v7.095C24 21.4 22.274 23 20.153 23"/>
                <path d="M11.573 18h-.004a1.274 1.274 0 0 1-.883-.356l-5.328-5.181a1.156 1.156 0 0 1 .013-1.686 1.283 1.283 0 0 1 1.76.013l4.447 4.325L24.874 2.35a1.283 1.283 0 0 1 1.76-.002c.487.465.488 1.22.002 1.686L12.454 17.65c-.234.224-.551.35-.881.35"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/checkStatus.js